import React, {useEffect, useState} from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import {useTranslation, Trans} from "react-i18next";
import CountUp from "react-countup";
import {handleScrollGenerator} from "../helpers/util";

export const Partners = (props) => {
    const { t } = useTranslation();
    const [playing, setPlaying] = useState(true);

    const settings = {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        dots: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    useEffect(() => {
        const handleScroll = handleScrollGenerator('player-partners', setPlaying);
        window.addEventListener('scroll', handleScroll);
        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

  return (
    <div id="partners" className="text-center">
      <div className="container-fluid">
          <div className="container">
            <div className="col-md-10 section-title">
              <h2>{t('partners.title')}</h2>
            </div>
            <div className="row">
                <div className="slider-container">
                    <Slider {...settings}>
                        {props.data && props.data.map((d) => (
                            <div key={d.img}>
                              <img src={d.img} alt={d.img}/>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
          </div>
          <div className="row bg-asphalt">
              <div className="container-fluid partners-container">
                  <div className="col-md-4">
                      <h3>{t('partners.goal')}</h3>
                      <div className="border"/>
                      <p><Trans i18nKey="partners.projects"/></p>
                  </div>
                  <div className="col-md-4">
                      <h3>{t('partners.quality')}</h3>
                      <div className="border"/>
                      <p><Trans i18nKey="partners.experienced"/></p>
                  </div>
                  <div className="col-md-4">
                      <h3>{t('partners.cooperation')}</h3>
                      <div className="border prof-cop"/>
                      <p><Trans i18nKey="partners.skilled"/></p>
                  </div>
              </div>
          </div>
          <div className="container">
              <div className="row our-achievements">
                  <div className="col-md-6">
                      <div className="video-container" id="player-partners">
                          <ReactPlayer
                              url="https://www.youtube.com/watch?v=MsmGH5WMEck"
                              controls
                              width="100%"
                              height="100%"
                              playing={playing}
                              light={"<img src='/img/track.png' alt='track'>"}
                          />
                      </div>
                  </div>
                  <div className="col-md-offset-1 col-md-5">
                      <h2>{t('partners.achievements')}</h2>
                      <p>{t('partners.innovative')}</p>
                  </div>
              </div>
          </div>
          <div className="row statistics">
              <div className="container-fluid statistics-container">
                  <div className="col-md-2">
                      <div className="mob-pt-count">
                          <CountUp
                              start={0}
                              end={100}
                              duration={5}
                              prefix={'+ '}
                              suffix={'k'}
                              className="count-up"
                              enableScrollSpy={true}
                              scrollSpyOnce={true}/>
                          <p>{t('partners.paved')}</p>
                      </div>
                  </div>
                  <div className="col-md-1">
                      <div className='right-border'/>
                  </div>
                  <div className="col-md-3">
                      <div>
                          <CountUp
                              start={0}
                              end={20}
                              duration={6}
                              prefix={'+ '}
                              className="count-up"
                              enableScrollSpy={true}
                              scrollSpyOnce={true}/>
                          <p>{t('partners.experiance')}</p>
                      </div>
                  </div>
                  <div className="col-md-1 prl">
                      <div className='right-border'/>
                  </div>
                  <div className="col-md-2">
                      <div>
                          <CountUp
                              start={0}
                              end={50}
                              duration={6}
                              prefix={'+ '}
                              className="count-up"
                              enableScrollSpy={true}
                              scrollSpyOnce={true}/>
                          <p>{t('partners.partners')}</p>
                      </div>
                  </div>
                  <div className="col-md-1">
                      <div className='right-border'/>
                  </div>
                  <div className="col-md-2">
                      <div className="mob-pb-count">
                          <CountUp
                              start={0}
                              end={40}
                              duration={6}
                              prefix={'+ '}
                              enableScrollSpy={true}
                              scrollSpyOnce={true}
                              className="count-up"/>
                          <p>{t('partners.staff')}</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  );
};
